import { lazy } from "react";
import { RoleRoute } from "../../app/router";

const Dashboard           = lazy(() => import("./pages/FormateurDashboard"));
const MesFormations       = lazy(() => import("./pages/MesFormations"));
const FormationsDispos    = lazy(() => import("./pages/FormationsDisponibles"));
const FormationDetail     = lazy(() => import("./pages/FormationDetail"));
const ModuleDetail        = lazy(() => import("./pages/ModuleDetail"));
const Profile             = lazy(() => import("./pages/FormateurProfile"));
const DemandesInscription = lazy(() => import("./pages/DemandesInscription"));
const Messagerie          = lazy(() => import("./pages/Messagerie"));

const wrap = (el) => <RoleRoute role="formateur">{el}</RoleRoute>;

export const formateurRoutes = [
  { path: "/formateur",                                element: wrap(<Dashboard />) },
  { path: "/formateur/dashboard",                      element: wrap(<Dashboard />) },
  { path: "/formateur/formations",                     element: wrap(<MesFormations />) },
  { path: "/formateur/disponibles",                    element: wrap(<FormationsDispos />) },
  { path: "/formateur/profile",                        element: wrap(<Profile />) },
  { path: "/formateur/formations/:id",                 element: wrap(<FormationDetail />) },
  { path: "/formateur/formations/:id/modules/:moduleId", element: wrap(<ModuleDetail />) },
  { path: "/formateur/inscriptions",                   element: wrap(<DemandesInscription />) },
  { path: "/formateur/Messagerie",                     element: wrap(<Messagerie />) },
];
